import React from "react";

export function MetricsBand({ stats }) {
  return (
    <section className="metrics-band" aria-label="Portfolio summary">
      <div className="page-width metrics-band__inner">
        <p data-reveal="fade">Built across interface, systems, and product.</p>
        <dl data-reveal="fade">
          {stats.map((stat) => (
            <div key={stat.label}>
              <dt>{stat.label}</dt>
              <dd>{stat.value}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}
